import { Box } from "@mui/material";
import UnionsList from "./UnionsList";
import { useEffect, useState } from "react";
import UnionView from "./UnionView";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import OverlaySpinner from "../../../common/components/functional/overlaySpinner/OverlaySpinner";
import { getUnions, selectAllUnionListItems } from "./unionsSlice";
import { UnionListItem } from "./unionsApi";

const UnionsPanel = () => {
  const [selectedUnionId, setSelectedUnionId] = useState<string>("");

  const dispatch = useAppDispatch();

  // Get unions from redux adapter
  const unions: UnionListItem[] = useAppSelector(selectAllUnionListItems);

  // Get loading state from redux
  const isLoading = useAppSelector(
    (state) =>
      state.unions.unionList.status === "pending" ||
      state.unions.unionDetails.status === "pending",
  );

  useEffect(() => {
    // If selectedUnionId is empty, it's the main view and it should fetch unions
    selectedUnionId === "" && dispatch(getUnions({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      width={"1000px"}
      sx={{
        background: "rgba(255, 255, 255, 1)",
        borderRadius: "12px",
        padding: "15px",
        boxShadow: "0px 4px 22px rgba(26, 42, 97, 0.08)",
      }}
    >
      <OverlaySpinner isLoading={isLoading} />
      {selectedUnionId ? (
        <UnionView
          selectedUnionId={selectedUnionId}
          setSelectedUnionId={setSelectedUnionId}
        />
      ) : (
        <UnionsList
          setSelectedUnionId={setSelectedUnionId}
          // Sort unions by tradeUnionNumber
          unions={unions.slice().sort((a, b) => {
            if (
              a.tradeUnionNumber === undefined &&
              b.tradeUnionNumber === undefined
            ) {
              return 0;
            } else if (
              a.tradeUnionNumber === undefined ||
              a.tradeUnionNumber === null
            ) {
              return -1;
            } else if (
              b.tradeUnionNumber === undefined ||
              b.tradeUnionNumber === null
            ) {
              return 1;
            } else {
              return a.tradeUnionNumber.localeCompare(b.tradeUnionNumber);
            }
          })}
        />
      )}
    </Box>
  );
};

export default UnionsPanel;
